import classes from './games.module.css';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import Button from '../../components/Button/Button';
import TopOffer from '../../components/TopOffer/TopOffer';
import JackpotStrip from '../../components/JackpotStrip/JackpotStrip';
import useDarkOffersBackground from '../../hooks/useDarkOffersBackground';
import { getPlayingNow } from '../../utils/playingNow';
import { getUserGeo } from '../../services/userGeoService';
import { getToroxGamingOffers, toCardOffer } from '../../services/toroxService';
import CategorySelector from '../Offers/CategorySelector';
import DeviceFilter from '../Offers/DeviceFilter';
import { DEVICE_FILTERS, filterOffersByDeviceFilter, filterOffersByPlatform, getUserPlatform, PLATFORMS } from '../../utils/device';

const Games = () => {
    const { user } = useAuth();
    const [ip, setIP] = useState("");
    const [offers, setOffers] = useState([]);
    const [country, setCountry] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deviceFilter, setDeviceFilter] = useState(() => {
        const p = getUserPlatform();
        return p === PLATFORMS.DESKTOP ? DEVICE_FILTERS.ALL : p;
    });
    useDarkOffersBackground();

    useEffect(() => {
        const fetchIPAndCountry = async () => {
            try {
                const ipRes = await axios.get("https://api.ipify.org/?format=json");
                const fetchedIP = ipRes.data.ip;
                setIP(fetchedIP);

                const geoRes = await getUserGeo(fetchedIP);
                const fetchedCountry = geoRes.country_code2;
                setCountry(fetchedCountry);

                console.log("User IP is " + fetchedIP);
                console.log("User country is " + fetchedCountry);
            } catch (error) {
                setError(error.message ? error.message : JSON.stringify(error));
                setLoading(false);
            }
        };

        fetchIPAndCountry();
    }, []);

    useEffect(() => {
        const fetchOffers = async () => {
            if (user?.id && ip) {
                try {
                    const toroxData = await getToroxGamingOffers(country);
                    const toroxArray = toroxData.data.offers;

                    const sortedOffers = toroxArray.sort((a, b) => b.conversion_rate - a.conversion_rate);

                    const top30Offers = sortedOffers.slice(0, 30);

                    const transformToroxOffers = top30Offers.map(offer => toCardOffer(offer, user.id, country));

                    setOffers(filterOffersByPlatform(transformToroxOffers, getUserPlatform()));
                } catch (error) {
                    setError(error.message ? error.message : JSON.stringify(error));
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchOffers();
    }, [user?.id, ip, country]);

    if (loading) {
        return <div style={{ color: '#f3e8ff', padding: '2rem', textAlign: 'center' }}>Loading...</div>;
    }

    if (error) {
        return <div style={{ color: '#f3e8ff', padding: '2rem', textAlign: 'center' }}>Error: {error}</div>;
    }

    const visibleOffers = filterOffersByDeviceFilter(offers, deviceFilter);

    return (
        <>
             <CategorySelector />
            <DeviceFilter value={deviceFilter} onChange={setDeviceFilter} />
            <div style={{ padding: '0 20px' }}>
                <JackpotStrip games={visibleOffers} surveys={[]} />
            </div>
            <h2 className={classes.sponsoredOffersHeading}>Available Games</h2>
            <ul className={classes.list}>
                {visibleOffers.map((offer, index) => (
                    <li key={offer.id} className={classes.item}>
                        <TopOffer
                            title_text={offer.title}
                            center_text={offer.description}
                            image_game={offer.imageUrl}
                            devices={offer.devices}
                            link={offer.link}
                            reward_payout={offer.reward}
                            events={offer.events}
                            rank={index}
                            isHot={index === 0}
                            hotLabel="🔥 MOST POPULAR"
                            playingNow={getPlayingNow(offer, index)}
                            glimmer
                        />
                    </li>
                ))}
            </ul>
        </>
    );
};

export default Games;